module.exports = __webpack_public_path__ + "img/momo_index_bg_title.bd5afe8d.png";